enum ActionTypes {
  ADD_USERS_IN_EVENT = "app/ADD_USERS_IN_EVENT",
  RESET_USERS_IN_EVENT = "app/RESET_USERS_IN_EVENT",
  USERS_IN_EVENT_LOADED = "app/USERS_IN_EVENT_LOADED",
}

export default ActionTypes;
